
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-blue-50"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/89ce65a415860e3da90921dded83bf21/bd71cfedaa6a51f8224035adf3627a39.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/70 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center w-full">
        <div className="text-left">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Safer Industry Through{' '}
            <span className="bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
              Intelligent Robotics
            </span>
          </h1>
          
          <p className="text-xl text-gray-700 mb-8 leading-relaxed max-w-2xl">
            Humanoids and robotic forklifts engineered for real factories and warehouses—deployed 
            with BrainCommerce's nationwide outsourcing network.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              <i className="ri-play-circle-line mr-2"></i>
              Request a Demo
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
